import { render } from "./PageNotFoundComponent.vue?vue&type=template&id=207dea16"
const script = {}

import "./PageNotFoundComponent.vue?vue&type=style&index=0&id=207dea16&lang=scss"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__